// extracted by mini-css-extract-plugin
module.exports = {"base":"fourteenStories3Ad1Widget-m__base__3c4yQ","wrapper":"fourteenStories3Ad1Widget-m__wrapper__14yBW","ad-slot":"fourteenStories3Ad1Widget-m__ad-slot__Ms1uU"};